// 登录检查工具函数
export function checkLogin() {
  const userInfo = localStorage.getItem('userInfo')
  if (!userInfo) {
    return {
      isLoggedIn: false,
      userInfo: null
    }
  }
  try {
    const user = JSON.parse(userInfo)
    return {
      isLoggedIn: !!user && !!user.id,
      userInfo: user
    }
  } catch (e) {
    return {
      isLoggedIn: false,
      userInfo: null
    }
  }
}

// 显示登录提示框
export function showLoginAlert(message = '请先登录后才能使用此功能') {
  if (window.__APP__) {
    // 如果有全局的app实例，可以直接调用openLogin
    window.__APP__.openLogin()
  }
  alert(message)
}

// 需要登录的页面列表
export const protectedPages = ['live', 'image', 'video', 'drama', 'openclaw', 'code']
